/* eslint-disable import/prefer-default-export */
export enum VoiceRecordingType {
  VOICEMAIL = 'VOICEMAIL',
  FORWARDED_CALL = 'FORWARDED_CALL',
  FNOL_STORY = 'FNOL_STORY',
}
